<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="is-2column"
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- 後で見る -->
    <!-- <transition name="toast">
      <PCBasicToast v-if="state.visibleToast" @closeToast="state.visibleToast = false">「設問」を後で見るに保存しました。</PCBasicToast>
    </transition> -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
        <div class="header-search-title">お知らせ</div>
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button"
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn"
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <div class="" id="navi">
          <div class="navigation-title">絞り込み</div>
          <div class="navigation-content">
            <nav class="list01 bg-02">
              <ul>
                <li class="list01-item"
                  v-for="(classification, index) in data.classifications" :key="'classifications_' + index"
                >
                  <div class="label">
                    <div class="formparts checkbox">
                      <input
                        :id="'classification_' + index"
                        type="checkbox"
                        :value="classification.code"
                        v-model="data.filterClassifications"
                      >
                      <label
                        :for="'classification_' + index"
                      >{{classification.value1}}<FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                  </div>
                </li>
              </ul>
              <ul>
                <li class="list01-item"
                  v-for="(category, index) in data.categories" :key="'category_' + index"
                >
                  <div class="label">
                    <div class="formparts checkbox">
                      <input
                        :id="'category_' + index"
                        type="checkbox"
                        :value="category.code"
                        v-model="data.filterCategories"
                      >
                      <label
                        :for="'category_' + index"
                      >{{category.value1}}<FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <main class="" id="main">
          <div class="box02 white">
            <div class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">お知らせ</h1>
              <span v-if="data.count !== null && data.count !== 0" class="box02-hdg-title-sup">{{data.count}}件</span>
              <span v-else-if="data.canload" class="box02-hdg-title-sup">0件</span>
            </div>
            <div class="box02-body" id="scroll-target"
              @scroll="handleScroll"
              style="height:calc(100vh - 108px);"
            >
              <div v-if="data.count">
                <PCPagenation
                  v-if="data.isPaginationShown"
                  :count="news.pagenation.count"
                  :per_page="news.search.per_page"
                  :currentPage="news.pagenation.currentPage"
                  @changePage="clickPageNation"
                />
                <div v-if="!news.isSearching">
                  <template v-for="(dateLists, index) in data.groupDateLists">
                    <div :key="'news_date_' + index" class="date">{{formatDate(index)}}</div>
                    <ul :key="'news_lists_' + index" class="list-result list-result-small">
                      <li v-for="(list, dateIndex) in dateLists" :key="'date_'+ index + 'list' + dateIndex" class="list-result-item">
                        <div class="list-result-item-main">
                          <div class="list-result-title">
                            <span v-if="list.type === 1" class="no-link">{{list.title}}</span>
                            <a v-else-if="list.type === 2" v-bind:href="list.url" target="_blank">{{list.title}}<FontawesomeIcon :icon="['far','external-link']" class="icn" /></a>
                            <a v-else-if="list.type === 3" @click="action.routeList(list)" role="button">{{list.title}}</a>
                            <span v-if="list.classification === 3 || list.classification === 2"
                              class="icon-label" :class="list.classification === 3 ? 'red' : 'gray'"
                            >{{ list.classification_name }}</span>
                          </div>
                          <p class="list-result-text">{{list.summary}}</p>
                          <div class="list-result-note">
                            <span v-if="list.category_name !== ''" class="list-result-sup">{{list.category_name}}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </template>
                </div>
                <FontawesomeIcon v-else :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" />
                <PCPagenation
                  v-if="data.isPaginationShown"
                  :count="news.pagenation.count"
                  :per_page="news.search.per_page"
                  :currentPage="news.pagenation.currentPage"
                  @changePage="clickPageNation"
                />
              </div>
              <div v-else-if="data.canload">
                <ul class="list-result list-result-small">
                  <li class="list-result-item">
                    表示する内容がありません。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted, watch } from '@vue/composition-api'
import * as _ from 'lodash'
import { InformationList } from '@/logic/information/InformationList'

import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'
import PCPagenation from '@/components/pc/partial/PCPagenation.vue'

export default defineComponent({
  components: {
    PCMenu,
    PCBasicToast,
    PCPagenation
  },
  setup (props, context) {
    return { ...InformationList(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.box02-body {
  overflow: auto;
  .date {
    padding: 32px 40px 8px;
    color: $color-sup;
  }
}
#navi {
  .list01 ul {
    padding: 10px 0;
    & + ul {
      border-top: 1px solid rgba(255,255,255,.1);
    }
  }
}

.list-result-title {
  .icn {
    margin-left: 8px;
  }
}
</style>
